/**
 * Cargo do responsável pela conta PJ — lista fechada desde out/2026 (decisão
 * do Bruno; era texto livre). Espelho de `shared/contants/JobTitles.ts` do
 * backend, que valida no cadastro. Contas antigas podem ter outro texto: a
 * tela que edita o cargo mantém o valor atual como opção.
 */
export const JOB_TITLES = [
  'Sócio',
  'Diretor',
  'Gerente',
  'Analista',
  'Estagiário',
] as const;
